const projects = [
    {
        code: 1,
        name: "accountOnboard",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 2,
        name: "accountantRecu",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 3,
        name: "accountCatchUp",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 4,
        name: "accountCleanUp",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 5,
        name: "accountConsul",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 6,
        name: "others",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 7,
        name: "contOnBoard",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 8,
        name: "contRecu",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 9,
        name: "contCatchUp",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 10,
        name: "contConsul",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 11,
        name: "others",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 12,
        name: "cfoOnboar",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 13,
        name: "cfoRecu",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 14,
        name: "cfoCatch",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 15,
        name: "cfoConsult",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 16,
        name: "others",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 17,
        name: "taxExRecu",
        country: ["US", "VE"]
    },
    {
        code: 19,
        name: "taxExConsult",
        country: ["US", "VE"]
    },
    {
        code: 20,
        name: "others",
        country: ["US", "VE"]
    },
    {
        code: 21,
        name: "practOnboard",
        country: ["US"]
    },
    {
        code: 39,
        name: "gcaPlatSubs",
        country: ["US"]
    },
    {
        code: 22,
        name: "smbOnboard",
        country: ["US"]
    },
    {
        code: 23,
        name: "bookRecu",
        country: ["US"]
    },
    {
        code: 24,
        name: "bookCatchUp",
        country: ["US"]
    },
    {
        code: 25,
        name: "bookCleanUp",
        country: ["US"]
    },
    {
        code: 26,
        name: "bookConsul",
        country: ["US"]
    },
    {
        code: 27,
        name: "others",
        country: ["US"]
    },
    {
        code: 28,
        name: "compStand",
        country: ["US"]
    },
    {
        code: 29,
        name: "compUpda",
        country: ["US"]
    },
    {
        code: 30,
        name: "others",
        country: ["US"]
    },
    {
        code: 31,
        name: "revStd",
        country: ["US"]
    },
    {
        code: 32,
        name: "revUpda",
        country: ["US"]
    },
    {
        code: 33,
        name: "others",
        country: ["US"]
    },
    {
        code: 34,
        name: "xeroUpda",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 35,
        name: "xeroConsul",
        alt_name: "Xero consulting",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 36,
        name: "kiipBankSet",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 37,
        name: "kiipTaxSet",
        country: ["LA", "VE"]
    },
    {
        code: 38,
        name: "otherSetup",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 40,
        name: "xeroSusb",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 41,
        name: "kiipBankSusb",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 42,
        name: "kiipTaxSusb",
        country: ["LA", "VE"],
    },
    {
        code: 69,
        name: "kiipRepSusb",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 70,
        name: "kiipRepSetup",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 43,
        name: "customerSup",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 44,
        name: "xeroSubs",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 45,
        name: "arAuto",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 68,
        name: "apAuto",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 46,
        name: "accoServ",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 47,
        name: "contServ",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 48,
        name: "finanServ",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 49,
        name: "taxConsult",
        country: ["US", "VE"]
    },
    {
        code: 50,
        name: "softConsult",
        alt_name: "Xero consulting",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 51,
        name: "analyFee",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 52,
        name: "leadFee",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 53,
        name: "manaFee",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 54,
        name: "directFee",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 55,
        name: "partnFee",
        country: ["US", "GB", "LA", "VE"]
    },
    {
        code: 56,
        name: "munBar",
        country: ["VE"]
    },
    {
        code: 57,
        name: "munSuc",
        country: ["VE"]
    },
    {
        code: 58,
        name: "munLib",
        country: ["VE"]
    },
    {
        code: 59,
        name: "munChac",
        country: ["VE"]
    },
    {
        code: 60,
        name: "munOther",
        country: ["VE"]
    },
    {
        code: 61,
        name: "igp",
        country: ["VE"]
    },
    {
        code: 62,
        name: "fonacit",
        country: ["VE"]
    },
    {
        code: 63,
        name: "fnd",
        country: ["VE"]
    },
    {
        code: 64,
        name: "fona",
        country: ["VE"]
    },
    {
        code: 65,
        name: "sunbiz",
        country: ["US"]
    },
    {
        code: 66,
        name: "eeffVis",
        country: ["VE"]
    },
    {
        code: 67,
        name: "others",
        country: ["VE", "US", "GB", "LA"]
    },
    {
        code: 71,
        name: "kiipBankBasicPlus",
        country: ["VE", "US", "GB", "LA"]
    },
    {
        code: 72,
        name: "kiipBankProPlus",
        country: ["VE", "US", "GB", "LA"]
    },
    {
        code: 73,
        name: "kiipBankAdvPlus",
        country: ["VE", "US", "GB", "LA"]
    },
    {
        code: 74,
        name: "accountExpress",
        country: ["VE", "US", "GB", "LA"]
    },
    {
        code: 75,
        name: "bookExpress",
        country: ["VE", "US", "GB", "LA"]
    }
]

export default projects;